import { render, staticRenderFns } from "./refundAndCancellations.vue?vue&type=template&id=35c84d56&scoped=true"
var script = {}
import style0 from "./refundAndCancellations.vue?vue&type=style&index=0&id=35c84d56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c84d56",
  null
  
)

export default component.exports